export default { a: [
{ x: 0, y: 1},
{ x: 1, y: 1},
{ x: 2, y: 2},
{ x: 3, y: 8},
{ x: 4, y: 8},
{ x: 5, y: 11},
{ x: 6, y: 16},
{ x: 7, y: 18},
{ x: 8, y: 20},
{ x: 9, y: 29},
{ x: 10, y: 29},
{ x: 11, y: 40},
{ x: 12, y: 51},
{ x: 13, y: 52},
{ x: 14, y: 66},
{ x: 15, y: 83},
{ x: 16, y: 114},
{ x: 17, y: 144},
{ x: 18, y: 194},
{ x: 19, y: 235},
{ x: 20, y: 252},
{ x: 21, y: 336},
{ x: 22, y: 449},
{ x: 23, y: 507},
{ x: 24, y: 599},
{ x: 25, y: 651},
{ x: 26, y: 725},
{ x: 27, y: 823},
{ x: 28, y: 908},
{ x: 29, y: 983},
{ x: 30, y: 1109},
{ x: 31, y: 1191},
{ x: 32, y: 1278},
{ x: 33, y: 1366},
{ x: 34, y: 1337},
{ x: 35, y: 1396},
{ x: 36, y: 1463},
{ x: 37, y: 1523},
{ x: 38, y: 1594},
{ x: 39, y: 1662},
{ x: 40, y: 1722},
{ x: 41, y: 1787},
{ x: 42, y: 1939},
{ x: 43, y: 2059},
{ x: 44, y: 2137},
{ x: 45, y: 2210},
{ x: 46, y: 2281},
{ x: 47, y: 2329},
{ x: 48, y: 2297},
{ x: 49, y: 2376},
{ x: 50, y: 2257},
{ x: 51, y: 2351},
{ x: 52, y: 2451},
{ x: 53, y: 2558},
{ x: 54, y: 2597},
{ x: 55, y: 2684},
{ x: 56, y: 2782},
{ x: 57, y: 2926},
{ x: 58, y: 3037},
{ x: 59, y: 3114},
{ x: 60, y: 3146},
{ x: 61, y: 3233},
{ x: 62, y: 3306},
{ x: 63, y: 3423},
{ x: 64, y: 3577},
{ x: 65, y: 3719},
{ x: 66, y: 3781},
{ x: 67, y: 3763},
{ x: 68, y: 4013},
{ x: 69, y: 4240},
{ x: 70, y: 4519},
{ x: 71, y: 4632},
{ x: 72, y: 4854},
{ x: 73, y: 5189},
{ x: 74, y: 5406},
{ x: 75, y: 5656},
{ x: 76, y: 5385},
{ x: 77, y: 5544},
{ x: 78, y: 5985},
{ x: 79, y: 6613},
{ x: 80, y: 7305},
{ x: 81, y: 7996},
{ x: 82, y: 8172},
{ x: 83, y: 8703},
{ x: 84, y: 8715},
{ x: 85, y: 9397},
{ x: 86, y: 9577}
],
 c: [
{ x: 0, y: 1},
{ x: 1, y: 1},
{ x: 2, y: 2},
{ x: 3, y: 8},
{ x: 4, y: 9},
{ x: 5, y: 12},
{ x: 6, y: 17},
{ x: 7, y: 19},
{ x: 8, y: 21},
{ x: 9, y: 31},
{ x: 10, y: 34},
{ x: 11, y: 45},
{ x: 12, y: 56},
{ x: 13, y: 65},
{ x: 14, y: 79},
{ x: 15, y: 97},
{ x: 16, y: 128},
{ x: 17, y: 158},
{ x: 18, y: 225},
{ x: 19, y: 266},
{ x: 20, y: 301},
{ x: 21, y: 387},
{ x: 22, y: 502},
{ x: 23, y: 589},
{ x: 24, y: 690},
{ x: 25, y: 745},
{ x: 26, y: 820},
{ x: 27, y: 966},
{ x: 28, y: 1054},
{ x: 29, y: 1133},
{ x: 30, y: 1265},
{ x: 31, y: 1353},
{ x: 32, y: 1451},
{ x: 33, y: 1554},
{ x: 34, y: 1628},
{ x: 35, y: 1715},
{ x: 36, y: 1795},
{ x: 37, y: 1894},
{ x: 38, y: 1975},
{ x: 39, y: 2142},
{ x: 40, y: 2208},
{ x: 41, y: 2277},
{ x: 42, y: 2443},
{ x: 43, y: 2571},
{ x: 44, y: 2669},
{ x: 45, y: 2758},
{ x: 46, y: 2839},
{ x: 47, y: 2941},
{ x: 48, y: 3031},
{ x: 49, y: 3144},
{ x: 50, y: 3288},
{ x: 51, y: 3435},
{ x: 52, y: 3607},
{ x: 53, y: 3780},
{ x: 54, y: 3892},
{ x: 55, y: 4003},
{ x: 56, y: 4127},
{ x: 57, y: 4285},
{ x: 58, y: 4428},
{ x: 59, y: 4532},
{ x: 60, y: 4681},
{ x: 61, y: 4783},
{ x: 62, y: 4887},
{ x: 63, y: 5020},
{ x: 64, y: 5208},
{ x: 65, y: 5371},
{ x: 66, y: 5611},
{ x: 67, y: 5776},
{ x: 68, y: 6034},
{ x: 69, y: 6278},
{ x: 70, y: 6563},
{ x: 71, y: 6879},
{ x: 72, y: 7134},
{ x: 73, y: 7478},
{ x: 74, y: 7805},
{ x: 75, y: 8068},
{ x: 76, y: 8371},
{ x: 77, y: 8809},
{ x: 78, y: 9283},
{ x: 79, y: 9931},
{ x: 80, y: 10649},
{ x: 81, y: 11353},
{ x: 82, y: 12076},
{ x: 83, y: 12628},
{ x: 84, y: 13228},
{ x: 85, y: 13933},
{ x: 86, y: 14702}
],
 m: [
{ x: 0, y: 0},
{ x: 1, y: 0},
{ x: 2, y: 0},
{ x: 3, y: 0},
{ x: 4, y: 1},
{ x: 5, y: 1},
{ x: 6, y: 1},
{ x: 7, y: 1},
{ x: 8, y: 1},
{ x: 9, y: 1},
{ x: 10, y: 2},
{ x: 11, y: 2},
{ x: 12, y: 2},
{ x: 13, y: 2},
{ x: 14, y: 2},
{ x: 15, y: 3},
{ x: 16, y: 3},
{ x: 17, y: 3},
{ x: 18, y: 4},
{ x: 19, y: 4},
{ x: 20, y: 4},
{ x: 21, y: 6},
{ x: 22, y: 8},
{ x: 23, y: 12},
{ x: 24, y: 17},
{ x: 25, y: 19},
{ x: 26, y: 20},
{ x: 27, y: 24},
{ x: 28, y: 27},
{ x: 29, y: 31},
{ x: 30, y: 36},
{ x: 31, y: 42},
{ x: 32, y: 43},
{ x: 33, y: 46},
{ x: 34, y: 53},
{ x: 35, y: 60},
{ x: 36, y: 65},
{ x: 37, y: 79},
{ x: 38, y: 82},
{ x: 39, y: 89},
{ x: 40, y: 95},
{ x: 41, y: 98},
{ x: 42, y: 105},
{ x: 43, y: 112},
{ x: 44, y: 122},
{ x: 45, y: 129},
{ x: 46, y: 132},
{ x: 47, y: 134},
{ x: 48, y: 142},
{ x: 49, y: 151},
{ x: 50, y: 159},
{ x: 51, y: 165},
{ x: 52, y: 176},
{ x: 53, y: 185},
{ x: 54, y: 192},
{ x: 55, y: 197},
{ x: 56, y: 207},
{ x: 57, y: 214},
{ x: 58, y: 218},
{ x: 59, y: 225},
{ x: 60, y: 237},
{ x: 61, y: 246},
{ x: 62, y: 260},
{ x: 63, y: 264},
{ x: 64, y: 273},
{ x: 65, y: 282},
{ x: 66, y: 293},
{ x: 67, y: 300},
{ x: 68, y: 305},
{ x: 69, y: 314},
{ x: 70, y: 319},
{ x: 71, y: 329},
{ x: 72, y: 353},
{ x: 73, y: 356},
{ x: 74, y: 363},
{ x: 75, y: 373},
{ x: 76, y: 382},
{ x: 77, y: 393},
{ x: 78, y: 403},
{ x: 79, y: 416},
{ x: 80, y: 433},
{ x: 81, y: 445},
{ x: 82, y: 452},
{ x: 83, y: 467},
{ x: 84, y: 484},
{ x: 85, y: 500},
{ x: 86, y: 508}
],
 r: [
{ x: 0, y: 0},
{ x: 1, y: 0},
{ x: 2, y: 0},
{ x: 3, y: 0},
{ x: 4, y: 0},
{ x: 5, y: 0},
{ x: 6, y: 0},
{ x: 7, y: 0},
{ x: 8, y: 0},
{ x: 9, y: 1},
{ x: 10, y: 3},
{ x: 11, y: 3},
{ x: 12, y: 3},
{ x: 13, y: 11},
{ x: 14, y: 11},
{ x: 15, y: 11},
{ x: 16, y: 11},
{ x: 17, y: 11},
{ x: 18, y: 27},
{ x: 19, y: 27},
{ x: 20, y: 45},
{ x: 21, y: 45},
{ x: 22, y: 45},
{ x: 23, y: 70},
{ x: 24, y: 74},
{ x: 25, y: 75},
{ x: 26, y: 75},
{ x: 27, y: 119},
{ x: 28, y: 119},
{ x: 29, y: 119},
{ x: 30, y: 120},
{ x: 31, y: 120},
{ x: 32, y: 130},
{ x: 33, y: 142},
{ x: 34, y: 238},
{ x: 35, y: 259},
{ x: 36, y: 267},
{ x: 37, y: 292},
{ x: 38, y: 299},
{ x: 39, y: 391},
{ x: 40, y: 391},
{ x: 41, y: 392},
{ x: 42, y: 399},
{ x: 43, y: 400},
{ x: 44, y: 410},
{ x: 45, y: 419},
{ x: 46, y: 426},
{ x: 47, y: 478},
{ x: 48, y: 592},
{ x: 49, y: 617},
{ x: 50, y: 872},
{ x: 51, y: 919},
{ x: 52, y: 980},
{ x: 53, y: 1037},
{ x: 54, y: 1103},
{ x: 55, y: 1122},
{ x: 56, y: 1138},
{ x: 57, y: 1145},
{ x: 58, y: 1173},
{ x: 59, y: 1193},
{ x: 60, y: 1298},
{ x: 61, y: 1304},
{ x: 62, y: 1321},
{ x: 63, y: 1333},
{ x: 64, y: 1358},
{ x: 65, y: 1370},
{ x: 66, y: 1537},
{ x: 67, y: 1713},
{ x: 68, y: 1716},
{ x: 69, y: 1724},
{ x: 70, y: 1725},
{ x: 71, y: 1918},
{ x: 72, y: 1927},
{ x: 73, y: 1933},
{ x: 74, y: 2036},
{ x: 75, y: 2039},
{ x: 76, y: 2604},
{ x: 77, y: 2872},
{ x: 78, y: 2895},
{ x: 79, y: 2902},
{ x: 80, y: 2911},
{ x: 81, y: 2912},
{ x: 82, y: 3452},
{ x: 83, y: 3458},
{ x: 84, y: 4029},
{ x: 85, y: 4036},
{ x: 86, y: 4617}
]};
